import React, { LazyExoticComponent, lazy } from "react";

// interface components
type routerHandlersType = {
  url: string;
  component: LazyExoticComponent<() => React.JSX.Element>;
};

export const routeHandlers: Record<string, routerHandlersType> = {
  Dashboard: {
    url: "/",
    component: lazy(() => import("../../Pages/DashBoardModule/Dashboard")),
  },
  MyReports: {
    url: "/my-reports",
    component: lazy(() => import("../../Pages/MyReportsModule/MyReports")),
  },
  MyReportDetail: {
    url: "/my-reports/:id",
    component: lazy(() => import("../../Pages/MyReportsModule/MyReportDetail")),
  },
  MeetingSchedule: {
    url: "/meeting-schedule",
    component: lazy(
      () => import("../../Pages/MeetingScheduleModule/MeetingSchedule")
    ),
  },
  MeetingScheduleDetail: {
    url: "/meeting-schedule/:meeting_id",
    component: lazy(
      () => import("../../Pages/MeetingScheduleModule/MeetingScheduleDetail")
    ),
  },
  Archive: {
    url: "/archive",
    component: lazy(() => import("../../Pages/Archive")),
  },
  RadicalFocusSetting: {
    url: "/radical/focus/settings",
    component: lazy(() => import("../../Pages/RadicalFocusSetting")),
  },
  InitiativeTracking: {
    url: "/initiative/tracking",
    component: lazy(() => import("../../Pages/InitiativeTracking")),
  },
  KpiReporting: {
    url: "/kpi/reporting",
    component: lazy(() => import("../../Pages/KpiReporting")),
  },
  KpiDetail: {
    url: "/kpi/detail/:kpiId",
    component: lazy(() => import("../../Pages/KpiDetail")),
  },
  ObjectiveOverview: {
    url: "/objective/overview",
    component: lazy(() => import("../../Pages/ObjectiveOverview")),
  },
  ActivityOverview: {
    url: "/activity/overview",
    component: lazy(() => import("../../Pages/RecurringActivityOverview")),
  },
  ProcessOverview: {
    url: "/processes/overview",
    component: lazy(() => import("../../Pages/ProcessOverview")),
  },
  ForeCast: {
    url: "/forecast/overview",
    component: lazy(() => import("../../Pages/ForeCast")),
  },
  BusinessModel: {
    url: "/business/model",
    component: lazy(() => import("../../Pages/BusinessModel")),
  },
  Market: {
    url: "/strategy/market",
    component: lazy(() => import("../../Pages/Market")),
  },
  Brand: {
    url: "/strategy/brand",
    component: lazy(() => import("../../Pages/Brand")),
  },
  CustomerFocus: {
    url: "/custom/focus",
    component: lazy(() => import("../../Pages/CustomerFocus")),
  },
  CustomerSegmentation: {
    url: "/custom/segmentation",
    component: lazy(() => import("../../Pages/CustomerSegmentation")),
  },
  OpsModel: {
    url: "/ops/model",
    component: lazy(() => import("../../Pages/OpsModel")),
  },
  PeopleCluture: {
    url: "/people/cluture",
    component: lazy(() => import("../../Pages/PeopleCluture")),
  },
  FinanceReporting: {
    url: "/finance/reporting",
    component: lazy(() => import("../../Pages/FinanceReporting")),
  },
  Planning: {
    url: "/planning",
    component: lazy(() => import("../../Pages/Planning")),
  },
  Feedback: {
    url: "/feedback",
    component: lazy(() => import("../../Pages/Feedback")),
  },
  ValuesAndPrinciples: {
    url: "/values-and-principles",
    component: lazy(() => import("../../Pages/ValuesAndPrinciples")),
  },
  FeedbackSetting: {
    url: "/feedback/settings",
    component: lazy(() => import("../../Pages/FeedbackSetting")),
  },
  Reviews: {
    url: "/reviews",
    component: lazy(() => import("../../Pages/Reviews")),
  },
  ReviewSetting: {
    url: "/reviews/settings",
    component: lazy(() => import("../../Pages/ReviewSetting")),
  },
  SuccessManager: {
    url: "/company/list",
    component: lazy(() => import("../../Pages/SuccessManager")),
  },
  ProfileSettings: {
    url: "/profile/settings",
    component: lazy(() => import("../../Pages/ProfileSettings")),
  },
};
